import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

/**
 * This component can hold one or more components, usually buttons or links, and will
 * make sure they are consistently laid out. It puts them on single line. They will be
 * spaced correcly. If they don't fit, they will wrap and still be spaced correctly.
 */ function CardButtonLayout(_param) {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('card-button-layout', className)
    }, rest), children);
}

export { CardButtonLayout as default };
//# sourceMappingURL=CardButtonLayout.js.map
